/* eslint-disable */
export const PARTY_AGNOSTIC_ASIN_TYPES: {
  [launchAsinServiceName: string]: string;
} = {
  soft_bundle: "Soft Bundle",
  "d+p_bundle": "D+P Bundle",
  vmp_bundle: "Virtual Multi-Pack Bundle",
  parent: "Parent",
  subscription: "Subscription",
};

export const FIRST_PARTY_ASIN_TYPES: {
  [launchAsinServiceName: string]: string;
} = {
  fresh_lot: "Fresh Lot",
  refurb: "Refurb",
  certified_refurb: "Certified Refurb",
  demo: "Demo",
  warranty: "Warranty",
  hard_bundle: "Hard Bundle",
  ad_removal: "Ad-Removal",
};

export const SECOND_PARTY_ASIN_TYPES: {
  [launchAsinServiceName: string]: string;
} = {
  mfa: "MFA",
};

export const THIRD_PARTY_ASIN_TYPES: {
  [launchAsinServiceName: string]: string;
} = {
  accessory: "Accessory (3p)",
  device: "Device (3p)",
  extended_warranty: "Extended Warranty",
};

export const NON_MFA_ASIN_TYPES: {
  [launchAsinServiceName: string]: string;
} = {
  non_mfa: "Non MFA",
};

export const FIRST_PARTY_ASIN_TYPES_EXTENDED: {
  [launchAsinServiceName: string]: string;
} = {
  ...FIRST_PARTY_ASIN_TYPES,
  "1p_non_mfa": "Non MFA (1p)",
};

export const SECOND_PARTY_ASIN_TYPES_EXTENDED: {
  [launchAsinServiceName: string]: string;
} = {
  ...SECOND_PARTY_ASIN_TYPES,
  "2p_non_mfa": "Non MFA (2p)",
};

// To denote placeholder ASINs created by IANService,
// See: https://code.amazon.com/packages/IANService/blobs/mainline/--/src/com/amazon/ian/factory/ItemDataFactory.java,
// https://i.amazon.com/issues/LEAP-7767, https://i.amazon.com/issues/LEAP-7608
export const PLACEHOLDER_LAUNCH_ASIN_TYPES: { [asinTypeKey: string]: string } =
  {
    fresh_lot_placeholder: "Fresh Lot Placeholder",
    certified_refurb_placeholder: "Certified Refurb Placeholder",
    refurb_placeholder: "Refurb Placeholder",
    warranty_placeholder: "Warranty Placeholder",
    demo_placeholder: "Demo Placeholder",
  };

export const LAUNCH_ASIN_TYPES: { [launchAsinServiceName: string]: string } = {
  ...PARTY_AGNOSTIC_ASIN_TYPES,
  ...FIRST_PARTY_ASIN_TYPES,
  ...SECOND_PARTY_ASIN_TYPES,
  ...THIRD_PARTY_ASIN_TYPES,
  ...NON_MFA_ASIN_TYPES,
  ...PLACEHOLDER_LAUNCH_ASIN_TYPES,
};

// To include the virtual ASIN types used exclusively by the searchSideBar component.
export const LAUNCH_ASIN_TYPES_EXTENDED: {
  [launchAsinServiceName: string]: string;
} = {
  ...PARTY_AGNOSTIC_ASIN_TYPES,
  ...FIRST_PARTY_ASIN_TYPES_EXTENDED,
  ...SECOND_PARTY_ASIN_TYPES_EXTENDED,
  ...THIRD_PARTY_ASIN_TYPES,
  ...NON_MFA_ASIN_TYPES,
  ...PLACEHOLDER_LAUNCH_ASIN_TYPES,
};

export const UNSUPPORTED_MARKETPLACES: string[] = ["SG", "IN"];

export const ASIN_LIVENESS_STATUSES: string[] = ["Live", "Partially Live"];

export const ASIN_CATALOG_LIVENESS_STATUSES: string[] = [
  "live",
  "partially_live",
  "not_live",
  "unknown",
];

export const ASIN_PARTIES: string[] = ["1p", "2p", "3p"];

export const RESULTS: string[] = ["fail", "pass_exception"];

// See https://quip-amazon.com/aP2XAJJYqQF3/ASIN-CentralOCL-Indicators-and-PSED-Value
export const NON_CUSTOMER_FACING_LAUNCH_ASIN_TYPE_VALUES: string[] = [
  "Certified Refurb",
  "Refurb",
  "Warranty",
  "Demo",
  ...Object.values(PLACEHOLDER_LAUNCH_ASIN_TYPES),
];

export const ASIN_ATTRIBUTE_VALUES_REQUIRING_WARNING: string[] = [
  "Unknown",
  ...NON_CUSTOMER_FACING_LAUNCH_ASIN_TYPE_VALUES,
  ...ASIN_LIVENESS_STATUSES,
  ...UNSUPPORTED_MARKETPLACES,
];

export const WEBLAB_STATUS: string[] = [
  "Inactive",
  "Weblab",
  "Weblab + Redirect",
  "Redirect",
];

export const BUYBOX_STATUS: string[] = [
  "Pre-Order",
  "Buy Now",
  "EMWR",
  "Invite",
  "No Data",
  "Unavailable",
];

export const ITEM_TYPES: { [key: string]: string } = {
  "ACCESSORY|PACKOUT": "Accessory",
  "DEVICE|PACKOUT": "Device",
};
